import uuid from 'node-uuid';
import moment from 'moment';
import "./Tile";

/** @namespace GIS.Map.Layer */
NS("GIS.Map.Layer");
/**
 * @class
 * @extends GIS.Map.Layer.Tile
 */
GIS.Map.Layer.MapBox = Class(GIS.Map.Layer.Tile, /** @lends GIS.Map.Layer.MapBox.prototype */ {
    // options
    title: "MapBox Tiles",
    projection: 'EPSG:3857',
    accessToken: null,
    mapId: null,
    tileNameSuffix: tileNameSuffix(),
    tilePixelRatio: tileRatio(),
    attributions: ["Картографические данные © MapBox, " + moment().format('YYYY')],
    url: "http://{a-c}.tiles.mapbox.com/v4/{mapId}/{z}/{x}/{y}{tileNameSuffix}.{tileFormat}?access_token={accessToken}",
    maxZoom: 22,
    /**
     * @type {string[]}
     * @protected
     */
    urlParams: ["mapId", "accessToken", "tileNameSuffix", "tileFormat"],
    /** @inheritDoc */
    initialize()
    {
        this.ParentCall();
        this.name = "GIS.Map.Layer.MapBox:" + uuid.v4();
    },
    /** @inheritDoc */
    optionsNames()
    {
        return this.ParentCall().concat(["mapId", "accessToken", "tileNameSuffix"]);
    },
    /** @inheritDoc */
    prepareOptions(options)
    {
        options = this.Parent(options);

        if (options.tilePixelRatio != null) {
            options.tilePixelRatio = tileRatio(options.tilePixelRatio);
            options.tileNameSuffix = tileNameSuffix(options.tilePixelRatio);
        }

        return options;
    }
});

/**
 * @param {number} [ratio]
 * @returns {number}
 * @private
 * @static
 */
function tileRatio(ratio)
{
    ratio = Util.coalesce(ratio, GLOBAL.devicePixelRatio);

    return ratio > 1 ? 2 : 1;
}

/**
 * @param {number} [ratio]
 * @returns {string}
 * @private
 * @static
 */
function tileNameSuffix(ratio)
{
    ratio = tileRatio(ratio);

    return ratio > 1 ? ["@", ratio, "x"].join("") : "";
}
